import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/api";

export const MailTable = ({ rows, mode = "sent", empty = "Nothing here yet." }) => {
  if (!rows.length) {
    return <p data-testid={`${mode}-empty`} className="text-sm text-slate-500 py-10 text-center border border-dashed border-slate-300 dark:border-slate-700 rounded-xl">{empty}</p>;
  }
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <table className="w-full text-sm" data-testid={`${mode}-table`}>
        <thead>
          <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200 dark:border-slate-800">
            <th className="px-4 py-3 font-semibold">Ref</th>
            <th className="px-4 py-3 font-semibold">Subject</th>
            <th className="px-4 py-3 font-semibold">{mode === "sent" ? "Recipient" : "From"}</th>
            <th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold">{mode === "sent" ? "Created" : "Claimed"}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.id} className="border-b last:border-0 border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
              <td className="px-4 py-3 font-mono text-xs"><Link data-testid={`mail-row-link-${m.reference}`} to={`/app/mail/${m.id}`} className="text-emerald-700 dark:text-emerald-400 hover:underline">{m.reference}</Link></td>
              <td className="px-4 py-3 max-w-[220px] truncate">{m.subject}</td>
              <td className="px-4 py-3 whitespace-nowrap">{mode === "sent" ? m.recipient_name : m.sender_name}</td>
              <td className="px-4 py-3"><div className="flex flex-wrap items-center gap-1.5"><StatusBadge status={m.status} testId={`row-status-${m.reference}`} />
                {mode === "sent" && m.delivery_problem && <span data-testid={`row-delivery-problem-${m.reference}`} className="inline-flex items-center gap-1 rounded-full bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 px-2 py-0.5 text-[10px] font-semibold"><AlertTriangle size={10} /> {m.text_only_problem ? "Text not delivered" : "Not delivered"}</span>}
              </div></td>
              <td className="px-4 py-3 text-xs font-mono text-slate-500 whitespace-nowrap">{fmtDate(mode === "sent" ? m.created_at : m.claimed_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
